import React from "react";
import SampleDp from "../../../../../../assets/Images/sample-dp.png";
import "../../../../../../styles/ComponentsStyles/Universal/CustomHeaderBox.style.css";
// Step 1: Define the data
const headerData = {
  profileImage: SampleDp,
  name: "Taufik Alam",
  gender: "Male",
  id: "SM0523019",
  designation: "Teacher",
  department: "Science",
  grade: "A+",
  position: "Biology Teacher",
  lastFeeDate: "23 Oct, 2025",
  lastMonth: "August",
};

// Step 2: Use the data in your component
const HistoryCustomHeaderBox = ({ action }) => {
  return (
    <div className="CustomHeaderTitleContainer">
      <div className="frontSection">
        <div
          style={{ display: "flex", alignItems: "center", gap: "2rem" }}
          className="container"
        >
          <div className="profile-dp">
            <img src={headerData.profileImage} alt="dp" />
            <div className="infoContainer">
              <div className="name">{headerData.name}</div>
              <div className="gender">{headerData.designation}</div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div className="id">#{headerData.id}</div>
            <div className="class">{headerData.position}</div>
            <div className="grade" style={{ color: "var(--tableColor)" }}>
              Grade: {headerData.grade}
            </div>
          </div>
        </div>
      </div>
      <div className="date">
        <button className="actionBtn">Download</button>
      </div>
    </div>
  );
};

export default HistoryCustomHeaderBox;
